export const cardsData = [
  {
    heading: "Mission Statement",
    description:
      "Our mission is to provide highest level of quality construction services through efficient management of resources with enhanced ability to deliver on time and to create maximum value for our clients through novelty, integrity and exceptional performance.",
  },
  {
    heading: "Objectives",
    description:
      "To set a benchmark in construction: build with exceptional quality, exhibit outstanding performance in every project and consistently ensure customer satisfaction.",
  },
  {
    heading: "Capabilities",
    description:
      "HHH Construction Company is a multi-faceted enterprise whose experience covers every aspect of the construction industry. Our staff has garnered sophistication in dealing with difficult projects and boasts of a track record that includes satisfied clients and timely completions,ealing with life construction manti-facetede",
  },
];
